import { useState, useEffect } from 'preact/hooks';

interface ILegacyMediaQueryList {
	addListener(callback: (e: MediaQueryListEvent) => void): void;
	removeListener(callback: (e: MediaQueryListEvent) => void): void;
}

const MOBILE_BREAKPOINT = 1023;

export const useIsMobile = () => {
	const [isMobile, setIsMobile] = useState(
		typeof window !== 'undefined'
			? window.innerWidth < MOBILE_BREAKPOINT
			: false,
	);

	useEffect(() => {
		if (typeof window === 'undefined') return;

		const mediaQuery = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`);

		const handleChange = (e: MediaQueryListEvent) => {
			setIsMobile(e.matches);
		};

		if (mediaQuery.addEventListener) {
			mediaQuery.addEventListener('change', handleChange);
		}
		// Legacy Support (Safari < 14) - Type safe cast
		else {
			(mediaQuery as unknown as ILegacyMediaQueryList).addListener(
				handleChange,
			);
		}

		// Initial check
		setIsMobile(mediaQuery.matches);

		return () => {
			if (mediaQuery.removeEventListener) {
				mediaQuery.removeEventListener('change', handleChange);
			} else {
				(mediaQuery as unknown as ILegacyMediaQueryList).removeListener(
					handleChange,
				);
			}
		};
	}, []);

	return isMobile;
};
